import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SupervisorLayout from '../../components/SupervisorLayout';
import SupervisorSalesMonitoringResults from './SupervisorSalesMonitoringResults';
import SupervisorBankCodeField from '../../components/SupervisorBankCodeField';
import SupervisorGroupCodeField from '../../components/SupervisorGroupCodeField';
import LotteryCodeField from '../../components/LotteryCodeField';
import DateField from '../../components/DateField';
import { todayISO } from '../../utils/date';
import './SupervisorSalesMonitoringPage.css';

// Variante superviseur (2026-09-16) de pages/central/SalesMonitoringPage.jsx —
// pas de radio All/Group/Supervisor/Bank, remplace par des champs Banque/Groupe
// optionnels et mutuellement exclusifs restreints a SES banks/groups. Meme
// UI/UX que la company (texte + icone 🔍 + modal de recherche + nom resolu,
// PAS de <select> — demande explicite 2026-09-17 "les filtre de group et de
// bank doit etre de la meme facon que la company"). Champs sans effet reel
// meme cote company (Refresh Every, Multiple Tabs, Zone ID) retires. Lottery
// utilise LotteryCodeField (deja le resolve-on-blur voulu).
const SupervisorSalesMonitoringPage = () => {
  const [showResults, setShowResults] = useState(false);
  const [bankId, setBankId] = useState('');
  const [bankName, setBankName] = useState('');
  const [groupId, setGroupId] = useState('');
  const [groupName, setGroupName] = useState('');
  const [date, setDate] = useState(todayISO());
  const [lottery, setLottery] = useState('0');
  const [lotteryName, setLotteryName] = useState('');

  const handleSearch = (e) => {
    e.preventDefault();
    setShowResults(true);
  };

  if (showResults) {
    return (
      <SupervisorSalesMonitoringResults
        date={date}
        tirage={lottery}
        bankId={bankId}
        groupId={groupId}
        onBack={() => setShowResults(false)}
      />
    );
  }

  return (
    <SupervisorLayout>
      <p className="svsm-breadcrumb">
        Ruta : <Link to="/supervisor/dashboard" className="svsm-link">Menu</Link>
        {' >> '}
        <Link to="/supervisor/central" className="svsm-link">Central</Link>
        {' >> '}
        <Link to="/supervisor/sales-monitoring" className="svsm-link">Suivi des ventes</Link>
      </p>

      <div className="svsm-card">
        <div className="svsm-card-header">
          <span className="svsm-card-title">Suivi des ventes</span>
        </div>
        <div className="svsm-card-body">
          <form onSubmit={handleSearch} className="svsm-form">
            <div className="svsm-row">
              <label className="svsm-label">Banque</label>
              <SupervisorBankCodeField
                value={bankId}
                name={bankName}
                onChange={(id) => { setBankId(id); setBankName(''); }}
                onResolve={(id, nm) => {
                  setBankId(id); setBankName(nm);
                  setGroupId(''); setGroupName('');
                }}
                inputClass="svsm-input svsm-input-sm"
                iconClass="svsm-icon svsm-icon-btn"
                nameClass="svsm-scope-name"
              />

              <label className="svsm-label svsm-label-gap">Groupe</label>
              <SupervisorGroupCodeField
                value={groupId}
                name={groupName}
                onChange={(id) => { setGroupId(id); setGroupName(''); }}
                onResolve={(id, nm) => {
                  setGroupId(id); setGroupName(nm);
                  setBankId(''); setBankName('');
                }}
                inputClass="svsm-input svsm-input-sm"
                iconClass="svsm-icon svsm-icon-btn"
                nameClass="svsm-scope-name"
              />
            </div>

            <div className="svsm-row">
              <label className="svsm-label">Date</label>
              <DateField className="svsm-input svsm-input-date" value={date} onChange={setDate} />
            </div>

            <div className="svsm-row">
              <label className="svsm-label">Loterie</label>
              <LotteryCodeField
                value={lottery}
                name={lotteryName}
                onChange={(code) => { setLottery(code); setLotteryName(''); }}
                onResolve={(code, nm) => { setLottery(code); setLotteryName(nm); }}
                inputClass="svsm-input svsm-input-sm"
                iconClass="svsm-icon svsm-icon-btn"
                nameClass="svsm-scope-name"
              />
            </div>

            <button type="submit" className="svsm-search-btn">Chercher</button>
          </form>
        </div>
      </div>
    </SupervisorLayout>
  );
};

export default SupervisorSalesMonitoringPage;
